import { toast, Zoom } from "react-toastify";

export const showToast = (message, delay = 3000) => {
    toast.success(message, {
        position: 'bottom-center',
        autoClose: delay,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        transition: Zoom,
    });
};

export const warningToast = (message, delay = 3000) => {
    toast.warning(message, {
        position: 'bottom-center',
        autoClose: delay,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        transition: Zoom,
    });
};

export const errorToast = (message, delay = 3000) => {
    toast.error(message, {
        position: 'bottom-center',
        autoClose: delay,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        transition: Zoom,
    });
};